import { ErrorBoundary } from 'react-error-boundary';
import { Toaster } from 'react-hot-toast';
import { RouterProvider } from 'react-router-dom';

import { providerConfig } from '@team/antd-config-provider';
import { App as AntdApp, ConfigProvider } from 'antd';

import { router } from '@/routes';

import { UserProvider } from './UserProvider';

const ErrorFallback = () => {
  return <div>error</div>;
};

export const App = () => {
  return (
    <UserProvider>
      <ErrorBoundary
        FallbackComponent={ErrorFallback}
        onError={(error, info) => console.error(error, info)}
      >
        <ConfigProvider {...providerConfig}>
          <Toaster
            position="top-center"
            toastOptions={{
              style: {
                whiteSpace: 'nowrap',
                maxWidth: 'none',
                fontSize: '14px',
                padding: '4px 8px',
              },
            }}
            containerStyle={{
              top: '50px',
            }}
          />
          <AntdApp>
            <RouterProvider router={router} />
          </AntdApp>
        </ConfigProvider>
      </ErrorBoundary>
    </UserProvider>
  );
};
